import { render, staticRenderFns } from "./PrivilegePage.vue?vue&type=template&id=698b4996&scoped=true&"
import script from "./PrivilegePage.vue?vue&type=script&lang=js&"
export * from "./PrivilegePage.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegePage.vue?vue&type=style&index=0&id=698b4996&scoped=true&lang=css&"
import style1 from "./PrivilegePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b4996",
  null
  
)

export default component.exports